"use strict";
// URL 操作工具函數
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanUrlParams = cleanUrlParams;
exports.buildApiUrl = buildApiUrl;
exports.getUrlParam = getUrlParam;
/**
 * 清除 URL 中的指定參數
 * @param params 要清除的參數名稱陣列
 */
function cleanUrlParams(params) {
    const urlParams = new URLSearchParams(window.location.search);
    params.forEach(param => urlParams.delete(param));
    const newUrl = `${window.location.pathname}${urlParams.toString() ? '?' + urlParams.toString() : ''}`;
    window.history.replaceState({}, document.title, newUrl);
}
/**
 * 構建 API URL
 * @param baseUrl 基礎 URL (可能包含或不包含 /api)
 * @param path API 路徑 (例如: '/auth/token/verify')
 * @returns 完整的 API URL
 */
function buildApiUrl(baseUrl, path) {
    const apiUrl = baseUrl.endsWith('/api') ? baseUrl : `${baseUrl}/api`;
    return `${apiUrl}${path}`;
}
/**
 * 從 URL 中獲取查詢參數
 * @param name 參數名稱
 * @returns 參數值，如果不存在則返回 null
 */
function getUrlParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}
